<template>
  <BaseInput
    v-model="getValue"
    type="text"
    class="input-search"
    v-bind="$attrs"
    maxlength="30"
    :focus="isFocus"
    :error-messages="getValue ? errorMessages : []"
    v-on="$listeners"
  >
    <template #side="{ focus }">
      <div class="input-search__icon-wrap">
        <SvgIcon name="lobby/search" class="input-search__icon" :class="{ focus }" />
      </div>
    </template>

    <template #body-right>
      <Transition name="fade">
        <button
          v-if="getValue && getValue.length > 2"
          type="button"
          class="input-search__close-btn"
          @click="getValue = ''"
        >
          <SvgIcon name="lobby/clear" class="input-search__icon-close" />
        </button>
      </Transition>
    </template>
  </BaseInput>
</template>

<script>
import BaseInput from '~/components/Base/Input'

export default {
  name: 'BaseInputSearch',
  components: { BaseInput },
  props: {
    value: { type: [String, Number] },
    errorMessages: { type: Array, default: () => [] },
    isFocus: { type: Boolean },
  },
  computed: {
    getValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
